import React from 'react';
import { useTranslation } from 'react-i18next';
import { ConfirmationModal } from '../../containers/confirmation-modal';

type ContentHiddenConfirmationModalProps = {
  closeModal: () => void;
  onConfirm: () => void;
  isLoading: boolean;
};

/**
 * @description Asks the user to confirm a group removal that would hide documents or templates from their owners
 */
export const ContentHiddenConfirmationModal = ({
  closeModal,
  onConfirm,
  isLoading,
}: ContentHiddenConfirmationModalProps) => {
  const { t } = useTranslation();

  return (
    <ConfirmationModal
      closeModal={closeModal}
      title={t('modals.removeFromGroup.confirmTitle')}
      buttonProps={{
        type: 'button',
        label: t('common.confirm'),
        isDestructive: false,
        onClick: onConfirm,
        isLoading,
      }}
    >
      {t('modals.removeFromGroup.visibilityWarning')}
    </ConfirmationModal>
  );
};
